import { render } from "./UserAgentAudit.vue?vue&type=template&id=3f854a92"
import script from "./UserAgentAudit.vue?vue&type=script&lang=js"
export * from "./UserAgentAudit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__